export default __webpack_public_path__ + "static/media/Mockup2.5ce8d402.png";